import objectParser from "../../../../utils/object-parser";
import {isEmpty} from "lodash";

/**
 * Parses a query string and retrieves filter and page state from it.
 * @param {string[]} validFilters The valid filter keys for the URL.
 *                                Any URL parameters not in this list (other than pagination and sort) will be ignored.
 * @returns {object}
 */
export default function getStateFromUrl(validFilters) {

    // Short-circuit if there's no query string
    if (!window.location.search) return null;

    const urlParams = new URLSearchParams(window.location.search);

    // Grab all the bits from the URL params
    const {perPage, sortBy, page, ...rest} = objectParser(Object.fromEntries(urlParams));

    const filters = {};

    // Loop through each additional param, seeing if it's worth adding to the filter list.
    for (const paramKey in rest) {
        // If the key isn't in our allowed filters list then we skip it
        if (!validFilters.includes(paramKey)) continue;

        const paramVal = rest[paramKey];

        // If the value of the param is empty or isn't a string, then we also skip it
        if (isEmpty(paramVal)) continue;

        // Otherwise, we split on commas. toString makes sure we're casting any numbers back to a string here.
        filters[paramKey] = paramVal.toString().split(',');
    }

    // Return the filters, pagination and sorting params all in one object
    return Object.assign({},
        {filters},
        !sortBy ? null : {sortBy},
        !perPage ? null : {perPage},
        !page ? null : {page},
    );
}